const SIGNAL_PRIORITY = Object.freeze({
    alert: 3,
    review: 2,
    mail: 1,
});

const TYPE_DEFAULT_SEVERITY = Object.freeze({
    alert: "critical",
    review: "warning",
    mail: "info",
});

export function normalizeCellSignals(signals) {
    if (!Array.isArray(signals)) return [];
    return signals
        .filter((signal) => signal?.type && Number(signal.count ?? 1) > 0)
        .map((signal) => ({
            ...signal,
            count: Number(signal.count ?? 1),
            severity: signal.severity || TYPE_DEFAULT_SEVERITY[signal.type] || "info",
        }))
        .sort((left, right) => (SIGNAL_PRIORITY[right.type] || 0) - (SIGNAL_PRIORITY[left.type] || 0));
}

export function resolveDisplayState(signals) {
    const normalizedSignals = normalizeCellSignals(signals);
    const primarySignal = normalizedSignals[0] || null;
    return {
        hasSignals: normalizedSignals.length > 0,
        signals: normalizedSignals,
        primarySignal,
        severity: primarySignal?.severity || "none",
        type: primarySignal?.type || "none",
        count: normalizedSignals.reduce((total, signal) => total + signal.count, 0),
    };
}
